import { ReactNode } from 'react';

import { ErrorBoundary } from '@oaknorth/component-core-v2';
import { useLocation } from '@oaknorth/util-routing';

function handleLazyLoadingError(e: Error) {
  // If we fail to load a chunk, it's probably because we've redeployed since the entrypoint was loaded
  // Let's refresh and get the new ones!
  if (process.env.NODE_ENV === 'production' && /Failed to fetch dynamically imported module:/.test(e.message)) {
    window.location.reload();
    return true;
  }
}
/**
 * Error boundary which automatically resets on changing path
 * Also triggers a reload on errors from lazy loading a route
 */
export function RoutingErrorBoundary({ children }: { children: ReactNode }) {
  const path = useLocation().pathname;
  return (
    <ErrorBoundary
      // Resets the error boundary when the path changes
      // So navigating to a different page closes the error
      resetKeys={[path]}
      onError={handleLazyLoadingError}
    >
      {children}
    </ErrorBoundary>
  );
}
